"use client";

import { usePathname } from "next/navigation";
import Footer from ".";
import { Locale } from "../../../i18n-config"

export default function ConditionalFooter({
  lang,
  dictionary,
}: {
  lang: Locale;
  dictionary: any;
}) {
  const pathname = usePathname();
  const shouldHideFooter =
    typeof pathname === "string" &&
    /\/tools\/(?:trade|pinnacle)(?:\/|$)/.test(pathname);

  if (shouldHideFooter) return null;

  return <Footer lang={lang} dictionary={dictionary} />;
}
